var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1553 10.2205C16.1553 8.64574 15.5297 7.13551 14.4162 6.02201C13.3027 4.90852 11.7925 4.28296 10.2178 4.28296C8.64305 4.28296 7.13282 4.90852 6.01933 6.02201C4.90583 7.13551 4.28027 8.64574 4.28027 10.2205C4.28027 11.7952 4.90583 13.3054 6.01933 14.4189C7.13282 15.5324 8.64305 16.158 10.2178 16.158C11.7925 16.158 13.3027 15.5324 14.4162 14.4189C15.5297 13.3054 16.1553 11.7952 16.1553 10.2205ZM15.0086 16.273C13.6949 17.3158 12.0287 17.9392 10.2178 17.9392C5.95391 17.9392 2.49902 14.4843 2.49902 10.2205C2.49902 5.95659 5.95391 2.50171 10.2178 2.50171C14.4816 2.50171 17.9365 5.95659 17.9365 10.2205C17.9365 12.0314 17.3131 13.6976 16.2703 15.0113L21.2393 19.9802C21.5881 20.3291 21.5881 20.8931 21.2393 21.2382C20.8904 21.5833 20.3264 21.5871 19.9813 21.2382L15.0086 16.273Z",
    fill: "#526077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.35498044b642cc2e15eec82202e24072.svg";
export { ForwardRef as ReactComponent };